import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.API_BASE_URL}/admin`;

class PurchasesService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getAllPurchases() {
    try {
      const response = await axios.get(
        `${BASE_URL}/all/purchased/policy`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data?.reason ||
          response.data?.message ||
          "Purchases fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting purchases",
      };
    }
  }

  async getPurchasesByPolicy(policySlug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/get/purchased_policy/${policySlug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data?.reason ||
          response.data?.message ||
          "Purchases fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while getting purchases",
      };
    }
  }
}

const purchasesService = new PurchasesService();
export default purchasesService;
